import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { universityClient } from '../client/universityClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

type Params = {
  university: number;
  specialization: number;
};

export const useUniversitySpecializationLevels = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getUniversitySpecialization, params],
    queryFn: () => universityClient.getUniversitySpecialization(params),
  });

  return {
    ...rest,
    levels: data || [],
  };
};
